module.exports = __webpack_public_path__ + "static/media/sublimacion_icon.cde0b960.svg";